import { render, staticRenderFns } from "./ext-product-price-list.vue?vue&type=template&id=820779aa&scoped=true"
import script from "./ext-product-price-list.vue?vue&type=script&lang=js"
export * from "./ext-product-price-list.vue?vue&type=script&lang=js"
import style0 from "./ext-product-price-list.vue?vue&type=style&index=0&id=820779aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820779aa",
  null
  
)

export default component.exports